import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core/lib/utils';
var timePickerStyle = function timePickerStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6,
    primary1 = _getThemeData.primary1;
  return css([".ant-time-picker-panel.ant-time-picker-panel{.ant-time-picker-panel-select{.ant-time-picker-panel-select-option-selected{background-color:", ";color:", ";}li{:hover{background-color:", ";}}}}.ant-time-picker-input.ant-time-picker-input{:hover,:active{border-color:", ";}:active,:focus{box-shadow:0 0 0 2px ", ";}}"], primary1, primary6, primary1, primary6, primary1);
};
export default timePickerStyle;